import { GeoResponse } from "@/pages/api/geo";
import { useQuery } from "@tanstack/react-query";

export function useGeo() {
  return useQuery({
    queryKey: ["geo"],
    queryFn: async () => {
      const res = await fetch("/api/geo/");
      if (!res.ok) {
        throw new Error("Failed to fetch geo information");
      }
      return res.json() as Promise<GeoResponse>;
    },
  });
}
